export const getVendorOptedSubscriptionServices = (
  casual_dining,
  fastfood,
  multi_service_business
) => {
  let services = [];
  if (casual_dining) {
    if (casual_dining?.event_management) services.push("Events");
    if (casual_dining?.offer_management) services.push("Offers");
    if (casual_dining?.ordering) services.push("Orders");
    if (casual_dining?.scan_and_pay) services.push("Scan & Pay");
    if (casual_dining?.seating) services.push("Seating");
    if (casual_dining?.menu_setup) services.push("Menu Setup");
  } else if (fastfood) {
    if (fastfood?.event_management) services.push("Events");
    if (fastfood?.offer_management) services.push("Offers");
    if (fastfood?.ordering) services.push("Orders");
    if (fastfood?.scan_and_pay) services.push("Scan & Pay");
    if (fastfood?.seating) services.push("Seating");
    if (fastfood?.menu_setup) services.push("Menu Setup");
  } else if (multi_service_business) {
    if (multi_service_business?.event_management) services.push("Events");
    if (multi_service_business?.offer_management) services.push("Offers");
    if (multi_service_business?.ordering) services.push("Orders");
    if (multi_service_business?.scan_and_pay) services.push("Scan & Pay");
    if (multi_service_business?.seating) services.push("Seating");
    if (multi_service_business?.menu_setup) services.push("Menu Setup");
  }
  return services.toString();
};
